import { jsx } from "react/jsx-runtime";
import Card from "antd/es/card";
import classnames from "../../utils/classnames.js";
import DealerCardContact from "./DealerCardContact.js";
import DealerCardLocation from "./DealerCardLocation.js";
import './DealerCard.css';/* empty css                */
const DealerCard = ({ children, className, ...props }) => {
  return /* @__PURE__ */ jsx(Card, { className: classnames("perxis-auto-dealer-card", className), ...props, children });
};
DealerCard.Location = DealerCardLocation;
DealerCard.Contact = DealerCardContact;
export {
  DealerCard as default
};
//# sourceMappingURL=DealerCard.js.map
